var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cookie-bar",on:{"click":function($event){return _vm.cookie_consent()}}},[_vm._v(" "+_vm._s((_vm.translations || {}).cookie_message)+" "),_c('button',{staticClass:"button button--green"},[_vm._v(_vm._s((_vm.translations || {}).cookie_consent_button))])])
}
var staticRenderFns = []

export { render, staticRenderFns }